import { Surface, StatusPill } from "@/components/ds";

export const Stat = ({ label, value, hint, testid }) => (
  <Surface className="p-4" data-testid={testid}>
    <p className="text-[10px] uppercase tracking-wide text-muted-foreground">{label}</p>
    <p className="mt-1 font-num text-lg">{value}</p>
    {hint && <p className="mt-0.5 text-[10px] text-muted-foreground/70">{hint}</p>}
  </Surface>
);

const PRODUCT_TONES = {
  PUBLICADO: "success",
  ESGOTADO: "warning",
  SEM_PRECO: "warning",
  FORA_DO_CATALOGO: "info",
  INATIVO: "danger",
};

export const ProductStatusPill = ({ status, label, testid }) => (
  <StatusPill tone={PRODUCT_TONES[status] || "info"} testid={testid}>
    {label}
  </StatusPill>
);

const COMMISSION_TONES = {
  PAGA: "success",
  PENDENTE: "warning",
  REVISAO: "info",
  ESTORNADA: "danger",
};

export const COMMISSION_LABELS = {
  PENDENTE: "Pendente",
  PAGA: "Paga",
  REVISAO: "Em análise",
  ESTORNADA: "Estornada",
};

export const CommissionPill = ({ status, testid }) => (
  <StatusPill tone={COMMISSION_TONES[status] || "info"} testid={testid}>
    {COMMISSION_LABELS[status] || status}
  </StatusPill>
);

/** Mês (YYYY-MM) de uma data ISO, sem depender do fuso do navegador. */
export const monthOf = (iso) => String(iso || "").slice(0, 7);

export const monthLabel = (ym) => {
  const [y, m] = String(ym || "").split("-");
  const names = ["jan", "fev", "mar", "abr", "mai", "jun",
                 "jul", "ago", "set", "out", "nov", "dez"];
  return `${names[Number(m) - 1] || m}/${String(y).slice(2)}`;
};
